import * as React from 'react';
import { useObservable } from 'react-use-observable';

import type User from 'classes/User';
import { checkPermission } from 'components/PermissionHide/checkPermission';
import eduzzAccountsService from 'v2/services/eduzzAccount';

import type { Route } from './routes';

function checkIfUserCanViewRouteByType(user: User, route: Route) {
  const { userTypes } = route;
  if (!userTypes) return true;
  const isPartner = user.general_term;
  if (userTypes.includes('producer')) return isPartner || user.producer;
  if (userTypes.includes('affiliate')) return isPartner || user.affiliate;
  const isOnlyCustomer = !user.producer && !user.affiliate && !isPartner;
  if (userTypes.includes('onlyCustomer')) return isOnlyCustomer;
  return false;
}

type PermissionProps = {
  children: React.ReactNode;
  route: Route;
};

function Permission({ children, route }: PermissionProps) {
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);
  const [permissions] = useObservable(() => eduzzAccountsService.getPermissions(), []);
  const [betaModules] = useObservable(() => eduzzAccountsService.getBetaModules(), []);

  if (!user || !permissions || !betaModules) return null;

  const userCanViewByType = checkIfUserCanViewRouteByType(user, route);

  const userNeedsPermission = route.permission ? !checkPermission(permissions, route.permission) : false;

  if (!userCanViewByType) return null;
  if (userNeedsPermission) return null;

  return <>{children}</>;
}

export { Permission };
